import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import EcosystemPage from './components/Ecosystem/EcosystemPage';

import Header from './components/Header/Header';
import MarketPage from './components/MarketPage/MarketPage';
import Footer from './components/Footer/Footer';

import './App.scss';
import StatsPage from './components/StatsPage/StatsPage';
import { useBreakpointContext } from './context-providers/BreakpointProvider';
import { ToasterContext } from './context-providers/ToasterProvider/ToasterProvider';
import { useSocket } from "./hooks/useSocket";
import BridgeDialog from "./components/modals/BridgeDialog/BridgeDialog";
import StakePage from "./components/Stake/StakePage";
import dayjs from "dayjs"
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc'

dayjs.extend(duration)
dayjs.extend(utc)

function App() {

    useSocket();
    const { xs } = useBreakpointContext();
    const { toasterElements } = useContext(ToasterContext);

    return (
        <div className="App">
            <Header />
            {xs && <div className="ToastersWrapper">
                <div className="content-container justify-end">
                    <div className="ToastersWrapper__container">
                        {toasterElements}
                    </div>

                </div>

            </div>}
            <Routes>
                <Route path="/markets/:marketId/bridge/*" element={<MarketPage />} >
                    <Route path="*" element={<BridgeDialog />} />
                </Route>
                <Route path="/markets/:marketId/:tab/:filter" element={<MarketPage />} />
                <Route path="/markets/:marketId/:tab" element={<MarketPage />} />
                <Route path="/markets/:marketId" element={<MarketPage />} />
                <Route path="/ecosystem" element={<EcosystemPage />} />
                <Route path="/stake/:tab" element={<StakePage />} />
                <Route path="/stake" element={<StakePage />} />
                <Route path="/stats" element={<StatsPage />} />
                <Route path="*" element={<MarketPage />} />
            </Routes>
            {!xs && <div className="ToastersWrapper">
                <div className="content-container justify-end">
                    <div className="ToastersWrapper__container">
                        {toasterElements}
                    </div>
                </div>

            </div>}
            <Footer />
        </div>
    );
}

export default App;
